import React, { useEffect } from "react";
import "./App.css";
import About from "./Components/About/About";
import Projects from "./Components/Projects/Projects";
import Contact from "./Components/Contact/Contact";
import HomePage from "./Components/HomePage/HomePage";
import Clients from "./Components/Clients/Clients";
import Blogs from "./Components/Blogs/Blogs";

function App() {
  useEffect(() => {
    const handleScroll = () => {
      const overlay = document.querySelector(".bg-overlay");
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const docHeight = document.body.scrollHeight;

      const distanceFromBottom = docHeight - (scrollY + windowHeight);
      const bottomThreshold = 300;

      // Apply black overlay based on scroll
      const maxScroll = 800;
      let opacity = scrollY / maxScroll;

      if (distanceFromBottom < bottomThreshold) {
        const fadeOutRatio = distanceFromBottom / bottomThreshold;
        opacity = 1 - fadeOutRatio;
      }

      overlay.style.opacity = Math.max(0, Math.min(1, opacity));
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <div className="animated-bg z-0">
        <div className="bg-overlay"></div>
      </div>
      <section id="home">
        <HomePage />
      </section>

      <section id="about">
        <About />
      </section>
      <section id="clients">
        <Clients />
      </section>
      <section id="projects">
        <Projects />
      </section>
      <section id="blogs">
        <Blogs />
      </section>
      <section id="contact">
        <Contact />
      </section>
    </>
  );
}

export default App;
